import { useMemo, useState } from "react";

export default function useUfgMonth() {
  const [anchorDate, setAnchorDate] = useState(() => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), 1);
  });

  const year = anchorDate.getFullYear();
  const month = anchorDate.getMonth() + 1;

  const monthValue = useMemo(() => {
    const m = (month < 10 ? "0" : "") + month;
    return `${year}-${m}`;
  }, [year, month]);

  const prevMonth = () =>
    setAnchorDate((d) => new Date(d.getFullYear(), d.getMonth() - 1, 1));

  const nextMonth = () =>
    setAnchorDate((d) => new Date(d.getFullYear(), d.getMonth() + 1, 1));

  const setFromInput = (value) => {
    if (!value) return;
    const [y, m] = value.split("-").map(Number);
    setAnchorDate(new Date(y, m - 1, 1));
  };

  return { year, month, monthValue, prevMonth, nextMonth, setFromInput };
}
